import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import * as echarts from "echarts";
import { v4 as uuidv4 } from "uuid";
import '@/assets/style/common.css';

// 引入百度地图
import BaiduMap from "vue-baidu-map"

import * as moment from 'moment';

import VueBarcode from '@xkeshi/vue-barcode';//生成条形码
import Print from 'vue-print-nb';//打印功能
Vue.use(Print)
Vue.component('barcode', VueBarcode);

Vue.use(BaiduMap,{ak:'GsvFN6ZH3Sju5EtyXcaCA7YBR20Dr9iB'})
Vue.prototype.$uuidv4 = uuidv4;

Vue.prototype.$moment = moment


Vue.use(ElementUI);
Vue.prototype.$echarts = echarts
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
